const SgiFormTextAreaEO = function () {
    return {
        alwBlk: true,
        // c: "desId",
        ctlH: 0,
        ctlN: "文本域",
        ctlRow: 4,
        ctlW: 24,
        desId: "EP_EO_UI_3102", //描述GUID
        isDis: false,
        isHdn: false,
        isScl: true, //滚动条（滚动状态）
        lblW: 6,
        maxL: 0,
        minL: 0,
        te: "文本域",
        inpPopTe: "请输入文本内容",
        // isLbl: false,
        lblAlg: "right",
        // isRead:false,
        // msfTgt:"qtip",

        // isGw:false, //x延伸状态
        // isSrp:true, //x键盘过滤状态
        // n:"描述GUID",
        // sNo:10,
        // t:"area",
        // useTim:0,
        // visible:true,
        // x:"0",
        // y:"0",
    }
}

export { SgiFormTextAreaEO };
export default SgiFormTextAreaEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiFormTextAreaEO.js